import React, { useContext } from 'react';
import { DateTimeUtils, Table, Person, OnHoverOnClick } from 'dyl-components';
import Contact from 'shared/Contact';
import { Link } from 'react-router-dom';
import { Checkbox } from 'semantic-ui-react';

import {
    KEY_CREATED_ON, KEY_OWNER, KEY_LAST_MODIFIED,
    KEY_CONVERT, KEY_ACCOUNT,
    KEY_ACTIONS,
    KEY_CO_OWNER
} from './constants';
import AccountLink from 'shared/AccountLink';
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';
import ContactConversionControls from 'shared/ContactConversionControls';
import HoverContent from 'shared/hoverContent';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';

export const ContactsRow = ({ contact, isColumnHidden, onSelectContactForConversion, refresh, actions }) => {
    const [selectedContacts, setSelectedContacts] = useContext(BulkActionsContext);

    const isSelected = (contact_id) => {
        return selectedContacts.includes(contact_id);
    }

    const onToggleContact = (contact_id) => {
        const newSelectedContacts = isSelected(contact_id) ? selectedContacts.filter(id => contact_id !== id) : [...selectedContacts, contact_id];
        setSelectedContacts(newSelectedContacts);
    }

    return (
        <Table.Row>
            <Table.Cell>
                <Checkbox checked={isSelected(contact.id)} onChange={() => { onToggleContact(contact.id) }} />
            </Table.Cell>
            {
                !isColumnHidden(KEY_CREATED_ON) &&
                <Table.Cell >
                    <div><b>{DateTimeUtils.formatEpoch(contact.created_ts, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                    <div>{DateTimeUtils.formatEpoch(contact.created_ts, DateTimeUtils.TIME_FORMAT)}</div>
                </Table.Cell>
            }
            {
                !isColumnHidden(KEY_LAST_MODIFIED) &&
                <Table.Cell>
                    {
                        contact.created_ts !== contact.activity && (
                            <React.Fragment>

                                <div><b>{DateTimeUtils.formatEpoch(contact.activity, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                                <div>{DateTimeUtils.formatEpoch(contact.activity, DateTimeUtils.TIME_FORMAT)}</div>
                            </React.Fragment>
                        )
                    }

                </Table.Cell>
            }
            <Table.Cell>
                <Contact
                    contact={{ ...contact, phone: contact?.phone[0] || contact?.phone }}
                    name={`${contact.first_name} ${contact.last_name}`}
                    linkToContact={
                        <RestrictedView type="link" userPermission={USER_PERMISSIONS.CONTACTS_VIEW} userRestrict assignmentIds={[(contact?.owner_id || 0), (contact?.coowner_id || 0)]}>
                            <Link to={`/contact/${contact.id}`}>{`${contact.first_name} ${contact.last_name}`}</Link>
                        </RestrictedView>
                    } />
                    
            </Table.Cell>
            {
                !isColumnHidden(KEY_ACCOUNT) &&
                <Table.Cell>
                    {contact?.account?.account_type &&
                        <AccountLink
                            id={contact.account.id}
                            name={contact.account.name}
                            type={contact.account.account_type}
                            account={contact.account}
                        />
                    }
                </Table.Cell>
            }

            {!isColumnHidden(KEY_OWNER) && (
                <Table.Cell>
                    {contact?.owned_by ? <OnHoverOnClick
                        hoverContent={
                            <HoverContent
                                user={contact.owned_by}
                            />
                        }
                        clickable={false}
                        trigger={contact?.owned_by ?
                            <div className='TableTruncateFixedWidth'>
                                <Person
                                    username={`${contact.owned_by.first_name} ${contact.owned_by.last_name}`}
                                    email={contact.owned_by.email}
                                    isInactiveUser={!contact.owned_by.active}
                                    popup={false}
                                    title={" "}
                                />
                            </div>
                            : undefined}
                    /> : "Unassigned"}
                </Table.Cell>
            )}
            {!isColumnHidden(KEY_CO_OWNER) && (
                <Table.Cell>
                    {contact?.co_owned_by ? <OnHoverOnClick
                        hoverContent={
                            <HoverContent
                                user={contact.co_owned_by}
                            />
                        }
                        clickable={false}
                        trigger={contact?.co_owned_by ?
                            <div className='TableTruncateFixedWidth'>
                                <Person
                                    username={`${contact.co_owned_by.first_name} ${contact.co_owned_by.last_name}`}
                                    email={contact.co_owned_by.email}
                                    isInactiveUser={!contact.co_owned_by.active}
                                    popup={false}
                                    title={" "}
                                />
                            </div>
                            : undefined}
                    /> : "Unassigned"}
                </Table.Cell>
            )}
            {
                !isColumnHidden(KEY_CONVERT) &&
                <Table.Cell>
                    {contact.account && !(contact.id === contact?.account?.pipeline_person_id) && (
                        <ContactConversionControls
                            account_id={contact.account.id}
                            account_stage={contact.module?.account_stage || 'contact'}
                            contactName={`${contact.first_name} ${contact.last_name}`}
                            contact_id={contact.id}
                            linkedAccountIsACustomer={contact.account.customer}
                            linkedAccountName={contact.account.name}
                            linkedAccountPrimaryContact={contact.account.primary_person_id}
                            refresh={refresh}
                            pipeline_id={contact?.module?.id}
                            isDeactivatedCustomer={contact?.account?.customer_status === 'canceled' || contact?.account?.customer_status === 'paused'}
                            location={contact.location}
                            phone={contact?.phone[0] || contact?.phone}
                            email={contact.email}
                            contact={contact}
                            onSelectForConversion={onSelectContactForConversion}
                        />
                    )}
                </Table.Cell>
            }
            {
                !isColumnHidden(KEY_ACTIONS) &&
                <Table.Cell width={1}>
                    {actions}
                </Table.Cell>
            }
        </Table.Row>
    );
}
